<template>
  <div
    :class="widget.widgetSettings.socialIconStyle"
    class="social-group"
  >
    <ul
      class="social-list"
    >
      <template v-for="(item, index) in widget.socialLinks">
        <li
          v-if="item.url !== 'https://' && item.url !== ''"
          :key="index"
          class="social-list-item"
        >
          <generic-link
            :href="item.url"
            :title="item.title"
            :class="item.title"
            class="social-link"
            target="_blank"
          >
            <span class="social-icon">
              <social-svg-icons :name="item.title" class="icon" />
            </span>
          </generic-link>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import GenericLink from '../ui-elements/generic-link'
import SocialSvgIcons from '../ui-elements/social-svg-icons'

export default {
  components: {
    GenericLink,
    SocialSvgIcons
  },
  props: {
    'widget': {
      type: Object,
      required: true
    }
  },
}

</script>
<style lang="scss" scoped>
  @import '~@scss/custom.scss';

  $social-icon-size: 1em !default;
  $social-icon-color: $white !default;
  $social-icon-border-color: rgba($border-color, .25) !default;

  //alignment props
  // align-right, aligns all social items right aligned with a single row on desktop devices
  // align-left, aligns all social items left aligned with a single row on desktop devices
  // align-vertical vertical column based alignment for use in a cta region on a footer

  //define positioning
  .social-group {

    ul {
      list-style: none;
    }
    //center alignment
    &.align-center {
      justify-content: center;
      .social-list-item {
       margin:0em .35em;
        @include media-breakpoint-up(sm) {
          .social-list-item {
            margin: 0em 0.5em;
          }
        }
      }
    }

    //left and right padding specific to left / right alignment
    &.align-left,
    &.align-right {
      justify-content: center;
      @include media-breakpoint-down(sm) {
        .social-list-item {
          margin: 0em 0.35em;
        }
      }
      //allow for more spacing on larger phones / tablets
      @include media-breakpoint-up(sm) {
        .social-list-item {
          margin: 0em 0.5em;
        }
      }
    }
    @include media-breakpoint-up(md) {
      &.align-right {
        justify-content: flex-end;
        flex-grow: 1;
        .social-list {
          margin-left: 1em;
        }
        .social-list-item {
          margin: 0em 0em 0em 1em;
        }
      }
      //specific to left alignment for desktop browsers
      &.align-left {
        justify-content: flex-start;
        .social-list-item {
          margin: 0em 1em 0em 0em;
        }
      }
    }

    //specific to right alignment for desktop browsers
    @include media-breakpoint-up(lg) {
      &.align-right {
        justify-content: flex-end;
        flex-grow: 1;
        .social-list {
          margin-left: 1em;
        }
        .social-list-item {
          margin: 0em 0em 0em 1em;
        }
      }
      //specific to left alignment for desktop browsers
      &.align-left {
        justify-content: flex-start;
        .social-list-item {
          margin: 0em 1em 0em 0em;
        }
      }
    }
    //vertical alignment settings
    &.align-vertical {
      .social-list {
        display: flex;
        flex-direction: column;
      }
      .social-link {
        display: flex;
      }
      .social-list-item {
        margin-bottom: 1em;
        display: flex;
      }
      //present the social label for vertical option
      .social-label {
        display: flex;
        align-items: center;
        padding-left: 1em;
      }
    }
  }
  //define structure
  .social-group {
    display: flex;
    .social-list {
      display: flex;
      flex-direction: row;
    }
    .social-link {
      display: flex;
    }
    .social-icon {
      box-sizing: content-box;
      height: 1em;
      width: 1em;
      padding: 0.75em;
      margin: 0em auto;
      text-align: center;
      line-height: inherit;
      position: relative;
      display: flex;
    }
   ::v-deep .icon {
      display: flex;
      width: 1em;
      height: 1em;
      color:var(--social-icon-color);
      align-items:center;
    }
    .social-label {
      display: none;
    }
  }

  //define theming, icon sizing for the social items
  .social-icon {
    border: 1px solid;
    border-color: var(--social-icon-border-color);
    border-radius: 100%;
    @include transition (background-color .3s, border-color .3s);
    font-size: $social-icon-size;
  }
  .social-link {
    //will increase both the lable and icon sizig
    color: $social-icon-color;

    .social-icon {
      .icon {
        @include transition (transform .3s);
      }
    }
    @include hover-focus {
      .social-icon {
        background-color: $social-icon-color;
      }
      .icon {
        color: var(--main-link-hover-color);
      }
    }
  }

  //define a mixin for brand colours, if chosen
  @mixin social-icon($color) {
    @include hover-focus {
      .social-icon {
        border-color: lighten($color, 15%);
        background-color: lighten($color, 15%);
      }
      .icon {
        color:$white;
      }
    }
    .social-icon {
      border-color: $color;
      background-color: $color;
    }
    .icon {
      color: $white;
    }
  }

  .social-group {
    &.branded {
      .social-list {
        .facebook {
          @include social-icon(#3b5998);
        }
        .twitter {
          @include social-icon(#1da1f2);
        }
        .linkedin {
          @include social-icon(#0077b5);
        }
        .youtube {
          @include social-icon(#ff0000);
        }
        .instagram {
          @include social-icon(#405de6);
        }
        .google-plus {
          @include social-icon(#dd4b39);
        }
        .vimeo {
          @include social-icon(#1ab7ea);
        }
        .pinterest {
          @include social-icon(#bd081c);
        }
        .skype {
          @include social-icon(#00aff0);
        }
      }
    }
  }
</style>
